<script>
	import NavTrackerActive from "./NavTrackerActive.svelte";
	import NavTrackerVisited from "./NavTrackerVisited.svelte";
	import NavTrackerNotVisited from "./NavTrackerNotVisited.svelte";

	import { pageNumber } from "../stores";

	export let pageList = [];

	const getNodeComponent = function (pageNumber, nodeIndex) {
		if (pageNumber == nodeIndex) {
			return NavTrackerActive;
		} else if (pageNumber > nodeIndex) {
			return NavTrackerVisited;
		} else {
			return NavTrackerNotVisited;
		}
	};
</script>

{#if $pageNumber > 0 && pageList.length > 0}
	<div class="tracker-root">
		{#each pageList as page}
			{#if page.showInTracker}
				<div class="tracker-node">
					<svelte:component this={getNodeComponent($pageNumber, page.pageIndex)} />
					<p class="tracker-node-title">{page.title}</p>
				</div>
			{/if}
		{/each}
	</div>
{/if}

<style>
	.tracker-root {
		display: flex;
		padding-top: 16px;
		padding-bottom: 40px;
		justify-content: center;
	}

	@media (max-width: 1250px) {
		.tracker-root .node-icon-connector {
			left: calc(100% + 11px);
			width: calc(90px - 100%);
		}
	}

	@media (max-width: 992px) {
		:global(.tracker-root .node-icon-connector) {
			left: calc(100% + 12px);
			width: calc(70px - 100%);
		}
	}

	@media (max-width: 840px) {
		:global(.tracker-root .node-icon-connector) {
			display: none;
		}
	}

	:global(.node-icon) {
		color: #fff;
		width: 40px;
		border: 4px solid transparent;
		height: 40px;
		display: flex;
		position: relative;
		align-items: center;
		border-radius: 15px;
		margin-bottom: 16px;
		justify-content: center;
		background-color: #fafafa;
	}

	@media (max-width: 840px) {
		:global(.node-icon) {
			width: 100%;
			height: 100%;
		}
	}

	:global(.node-icon.visiting) {
		position: relative;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
		background-color: #fff;
	}

	:global(.node-icon.visiting:after) {
		top: 50%;
		left: 50%;
		width: 35%;
		height: 35%;
		content: "";
		position: absolute;
		transform: translate(-50%, -50%);
		border-radius: 4px;
		background-color: #e6692d;
	}

	@media (max-width: 840px) {
		:global(.node-icon.visiting:after) {
			display: none;
		}
	}

	:global(.node-icon.not-visited) {
		border: 4px solid #dadada;
	}

	:global(.node-icon.visited) {
		background-color: #e6692d;
		cursor: pointer;
	}

	:global(.node-icon-connector) {
		top: 50%;
		left: 42px;
		width: 60px;
		height: 4px;
		position: absolute;
		transform: translate(0, -50%);
		border-radius: 2px;
		background-color: #ffa14a;
		background-color: #dadada;
	}

	:global(.node-icon-connector.active) {
		background-color: #ffa14a;
	}

	:global(.tracker-node) {
		width: 100px;
		margin: 0 6px;
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
	}

	:global(.tracker-node:last-child) {
		margin-right: 0;
	}

	:global(.tracker-node p) {
		width: 100%;
		word-wrap: break-word;
	}

	@media (max-width: 840px) {
		:global(.tracker-node) {
			width: 100%;
		}

		:global(.tracker-node p, .tracker-node svg) {
			display: none;
		}
	}

	:global(.tracker-node:last-child .node-icon .node-icon-connector) {
		display: none;
	}

	:global(.svg-tick-icon) {
		fill: currentColor;
		width: 1em;
		height: 1em;
		display: inline-block;
		font-size: 1.2857142857142856rem;
		transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
		flex-shrink: 0;
		user-select: none;
	}

	:global(.tracker-node-title) {
		font-size: 0.8571428571428571rem;
		font-weight: 400;
		line-height: 1.5;
		margin: 0;
	}
</style>
